import { render, staticRenderFns } from "./Boolean.vue?vue&type=template&id=64506fd0&"
import script from "./Boolean.vue?vue&type=script&lang=ts&"
export * from "./Boolean.vue?vue&type=script&lang=ts&"
import style0 from "./Boolean.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports